// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'browser';

export const Component = () => (
  <path d='M23.486 2H1.514c-.44 0-.781.147-1.074.44-.293.293-.44.634-.44 1.074v18.017c0 .44.147.782.44 1.075.293.293.634.44 1.074.44h21.972c.44 0 .781-.147 1.074-.44.293-.293.44-.635.44-1.075V3.514c0-.44-.147-.781-.44-1.074A1.436 1.436 0 0 0 23.486 2ZM.976 6.004v-2.49c0-.342.196-.488.537-.488h6.494v2.978H.976Zm23.047 1.025v14.502c0 .341-.195.488-.537.488H1.514c-.342 0-.537-.147-.537-.488V7.029h23.047-.001Zm0-3.516v2.49H8.984V3.025h14.502c.342 0 .537.147.537.488ZM2.002 5.027V4.002h.976v1.025h-.976Zm2.002 0V4.002h.976v1.025h-.976Zm2.001 0V4.002h.977v1.025h-.977Z' />
);

export const viewBox = '0 0 25 25';
